import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'cpf',
})
export class CpfPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value

    value = value.replace(/\D/g, '')
    if (value.length <= 3) return value
    if (value.length <= 6) return value.replace(/(\d{3})(\d{0,3})/, '$1.$2')
    if (value.length <= 9)
      return value.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3')
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4')
  }
}
